// extracted by mini-css-extract-plugin
export var dateLabel = "_2t-0";
export var dateLabelError = "_2t-1";
export var fullWidth = "_2t-2";
export var smaller = "_2t-3";